<template>
  <OrganismModal
    v-model:is-shown="isModalOpen"
    data-cy="enedis-consent-modal"
    :title="t('subscription.informationsSummary.enedisConsentModal.title')"
    size="lg"
    has-separator
    @cancel="handleClose"
  >
    <AtomText
      :text="t('subscription.informationsSummary.enedisConsentModal.content')"
      font-size="text-sm"
      data-cy="enedis-consent-modal-content"
    />
    <AtomText
      :text="t('subscription.informationsSummary.enedisConsentModal.validity')"
      font-size="text-sm"
      class="mt-4"
      data-cy="enedis-consent-modal-validity"
    />

    <template #footer="{ cancel }">
      <div class="flex justify-end max-sm:flex-col-reverse">
        <MoleculeButton
          data-cy="enedis-consent-modal-close-button"
          variant="tertiary"
          :label="t('common.close')"
          @click="cancel"
        />
      </div>
    </template>
  </OrganismModal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  isOpen: boolean;
}>();

const emit = defineEmits(['update:isOpen']);

const { t } = useI18n();

const isModalOpen = computed({
  get: () => props.isOpen,
  set: (newState: boolean) => {
    emit('update:isOpen', newState);
  },
});

const handleClose = () => (isModalOpen.value = false);
</script>
